import type { IState } from 'store';

export const getSelectedLanguageSelector = (state: IState) => state.language.selectedLanguage;
